import NewsletterRow from "./NewsletterRow";
import "../../styles/table.css";

export default function NewsLetterTable({ newsletters, onView }) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Message (Titre)</th>
            <th>Destinataires</th>
            <th>Contenu (Aperçu)</th>
            <th className="center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {newsletters && newsletters.length > 0 ? (
            newsletters.map((newsletter) => (
              <NewsletterRow
                key={newsletter.id}
                newsletter={newsletter}
                onView={onView}
              />
            ))
          ) : (
            <tr>
              <td colSpan="5" className="emptyTable">
                Aucune diffusion trouvée dans l'historique
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}